module.exports = __webpack_public_path__ + "img/FR16170.611769c3.png";